<template>
  <div class="operate-log-table">
    <SearchBar
      :list="tableInfo.selectedRows"
      ref="searchBar"
      @search="search"
      @click-preview="previewGoods"
      @batch-delete="batchDelete"
    />
    <Table ref="table" :info="tableInfo" @change-page="changePage">
      <template #top_url>
        商品链接
        <a-button v-if="tableInfo.list.length" type="primary" size="small" @click="batchCopyUrl">批量复制</a-button>
      </template>
      <template #status_str="{ record, text }">
        <a-tag style="font-size: 15px; margin-right: 0" :color="record.StatusTagColor">
          {{ text }}
        </a-tag>
      </template>
      <template #url="{ text }">
        <a-space>
          <a-tooltip placement="top">
            <template #title>
              <a :href="text" target="_blank" style="color: #fff">{{ text }}</a>
            </template>
            <a class="goods-url" :href="text" target="_blank">{{ text }}</a>
          </a-tooltip>
          <a-tooltip placement="top">
            <template #title> 点击复制商品链接 </template>
            <CopyOutlined @click="copyStr(text)" />
          </a-tooltip>
        </a-space>
      </template>
      <template #goods_id="{ record, text }">
        <div style="display: flex; flex-direction: column; align-items: center">
          <a href="#">{{ text }}</a>
          <a-space v-if="record.Status === 2 && record.AuditStatusStr" style="margin: 3px 0">
            <a-tag :color="record.AuditStatusStrColor" style="margin-right: 0; font-size: 14px">
              {{ record.AuditStatusStr }}
            </a-tag>
          </a-space>
          <a-tooltip v-if="record.EventReasons">
            <template #title>
              {{ record.EventReasons }}
            </template>
            <div v-show="record.EventReasons" class="fail-reasons-box">
              {{ record.EventReasons }}
            </div>
          </a-tooltip>
        </div>
      </template>
      <template #type_str="{ record }">
        {{ record.TypeStr }}
      </template>
      <template #fail_reason="{ record, text }">
        <a-tooltip v-if="record.Status !== 2" placement="top" overlayClassName="goods-info-tooltip">
          <template #title>{{ text }}</template>
          <div v-html="text" class="move-fail-reason-box"></div>
        </a-tooltip>
      </template>
      <template #goods_info="{ record }">
        <div class="goods-info" :style="{ 'line-height': record.Pic && record.Title ? 'inherit' : '75px' }">
          <a-tooltip v-if="record.Pic" placement="left" overlayClassName="goods-info-tooltip">
            <template #title>
              <img :src="record.Pic" width="330" height="330" />
            </template>
            <img :src="record.Pic" />
          </a-tooltip>
          <div>
            <a-tooltip placement="top" overlayClassName="goods-info-tooltip">
              <template #title>{{ record.Title }}</template>
              <span class="goods-name" @click="openDetail(record.Url)">{{ record.Title }}</span>
            </a-tooltip>
            <span>商品ID:{{ record.OutGoodsId }}</span>
          </div>
        </div>
      </template>
      <template #operate="{ record }">
        <a-space>
          <!-- <a-button v-if="record.Status === 2" type="primary" @click="openEditPage(record.GoodsId)">编辑</a-button> -->
          <a-button
            v-if="[0, 3].includes(record.Status) && record.TempId"
            type="primary"
            danger
            @click="previewGoods(record)"
          >
            铺货预览
          </a-button>
          <a-popconfirm
            overlayClassName="single-invalid-coupon-popover"
            placement="left"
            trigger="hover"
            @confirm="deleteLog(record.Id)"
          >
            <template #title>
              <h3>确定要删除上货记录吗</h3>
              <p>删除记录后，是不可恢复的，如确认后可点击【确定】按钮</p>
            </template>
            <a-button type="primary" danger ghost>删除</a-button>
          </a-popconfirm>
        </a-space>
      </template>
    </Table>
  </div>
</template>
<script>
import tableInfoHandler from "./table_info";
import api from "./api";
import SearchBar from "./components/search_bar";
import { CopyOutlined } from "@ant-design/icons-vue";
import { CopyToClipboard } from "@/utils/co_utils";
import handler from "./handler";
import { mapGetters } from "vuex";
export default {
  components: { SearchBar, CopyOutlined },
  data() {
    return {
      tableInfo: {
        page: 1,
        pageSize: 50,
        pageSizeOptions: ["30", "50", "100", "200", "300"],
        list: [],
        total: 0,
        tableScroll: { x: "1500px", y: "calc(100vh - 264px)" },
        loading: true,
        loadingTip: "正在加载商品数据中",
        selectedRows: [],
        selectedRowKeys: [],
        columns: tableInfoHandler.columns,
        renderSlot: ["top_url", "status_str", "goods_id", "url", "type_str", "goods_info", "fail_reason", "operate"],
      },
      params: {},
    };
  },
  watch: {
    // checkMall() {
    //   this.search();
    // },
  },
  computed: {
    ...mapGetters({
      checkMall: "mall_group/checkMall",
    }),
  },
  methods: {
    //search({ params }) {
    search(event) {
      if (event) {
        this.params = event.params;
      }
      const tableInfo = this.tableInfo;
      tableInfo.page = 1;
      tableInfo.selectedRows = [];
      tableInfo.selectedRowKeys = [];
      this.getData();
    },
    async getData() {
      const tableInfo = this.tableInfo;
      tableInfo.loading = true;
      this.params.page = tableInfo.page;
      this.params.size = tableInfo.pageSize;
      const { list, total } = await api.GetLogList(this.params);
      const colorMap = { 0: "red", 3: "red", 1: "orange" };
      list.map((item) => {
        item.StatusTagColor = colorMap[item.Status] || "blue";
      });
      tableInfo.list = list;
      handler.GetAuditStatusResult(tableInfo.list);
      tableInfo.total = total;
      tableInfo.loading = false;
    },
    openDetail(url) {
      window.open(url);
    },
    openEditPage(id) {
      window.open(`https://mms.pinduoduo.com/goods/goods_list/transfer?id=${id}`);
    },
    changePage(page, size) {
      this.tableInfo.page = page;
      this.tableInfo.pageSize = size;
      this.getData();
    },
    previewGoods(item) {
      this.tableInfo.selectedRows = [];
      this.tableInfo.selectedRowKeys = [];
      // 如果是单个商品预览需要先变成数组格式再传
      this.$emit("move-preview", {
        list: !Array.isArray(item) && [0, 3].includes(item.Status) && item.TempId ? [item] : item,
        key: "OutGoodsId",
      });
    },
    async deleteLog(id) {
      const { success, msg } = await api.DeleteLog(id);
      if (!success) return this.$message.warning(msg || "删除上货记录失败");
      setTimeout(() => {
        this.tableInfo.list = this.tableInfo.list.filter((item) => !item.Id !== id);
        this.tableInfo.total--;
        this.$message.success("删除上货记录成功");
        this.getData();
      }, 500);
    },
    async batchDelete(list) {
      const tableInfo = this.tableInfo;
      tableInfo.loading = true;
      for (let item of list) {
        await api.DeleteLog(item.Id);
      }
      tableInfo.selectedRows = [];
      tableInfo.selectedRowKeys = [];
      this.getData();
      this.$message.success(`删除${list.length}条上货记录成功, 数据更新会有延迟`);
    },
    openGoodsDetail(item) {
      if (item.Status === 2) {
        const id = item.OutGoodsId;
        switch (item.Type) {
          case 5:
            open(`https://detail.1688.com/offer/${id}.html`);
            break;
          // case 6:
          //   open(`https://item.taobao.com/item.htm?id=${id}`)
          //   break
        }
      }
    },
    copyStr(str) {
      CopyToClipboard(str);
      this.$message.success("已成功复制商品链接");
    },
    batchCopyUrl() {
      const selectedRows = this.tableInfo.selectedRows;
      if (!selectedRows?.length) return this.$message.warning("请至少选择一条数据");
      let str = "";
      for (let i in selectedRows) {
        str += `${selectedRows[i].Url}${i != selectedRows.length - 1 ? "\n" : ""}`;
      }
      CopyToClipboard(str);
      this.$message.success(`已成功复制【${selectedRows.length}】个上游商品链接，可以去粘贴`);
    },
  },
};
</script>
<style scoped lang="less">
@import "./index";
</style>
